import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as f } from "react";
import { useEvent as d } from './use-event.js';

function p(e, t, u) {
  var _f = f(u),
      _f2 = _slicedToArray(_f, 2),
      l = _f2[0],
      s = _f2[1],
      i = e !== void 0;

  return [i ? e : l, d(function (r) {
    return i || s(r), t == null ? void 0 : t(r);
  })];
}

export { p as useControllable };